import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Axios from '../axios'

import Gheader from "@/components/GlobleHeader/index";
import pConnectLineQuestion from "@/pages/Program/pconnectlinequestion";
import Home from '@/pages/Home/index'
import CourseBlog from '@/pages/Home/courseblog'
import Before from '@/pages/240words/240WordsBefore/index'
import After from '@/pages/240words/240WordsAfter/index'
import Lesson from '@/pages/240words/240SingleLesson/index'
import Card from '@/pages/240words/240WordCard/index'
import Part from '@/pages/240words/240LessonPart/index'
import Sentence from '@/pages/240words/240SingleSentence/index'
import Quiz from '@/pages/240words/240WordsQuiz/index'
import Login from '@/pages/Login/index'
import SelectCode from '@/pages/Login/selectCode'
import Agreement from '@/pages/UserAgreement/index.vue'
import PerfectInfo from '@/pages/PerfectInfo/index.vue'
import PageView from '@/pages/CommonView/index.vue'
import ExcessiveBuy from '@/pages/240words/ExcessiveBuy/index.vue'
import SAfter from '@/pages/Success/SuccessAfter/index'
import SBefore from '@/pages/Success/SuccessBefore/index'
import SCard from '@/pages/Success/SuccessCard/index'
import SLesson from '@/pages/Success/SuccessLesson/index'
import SWordList from '@/pages/Success/SuccessWordList/index'
import SQuestion from '@/pages/Success/SuccessQuestion/index'
import SStrategy from '@/pages/Success/SuccessStrategy/index'
import BAfter from '@/pages/BigCat/bafter'
import BBefore from '@/pages/BigCat/bbefore'
import BCard from '@/pages/BigCat/bcard'
import BFollow from '@/pages/BigCat/bfollow'
import BLesson from '@/pages/BigCat/blesson'
import BLearnWord from '@/pages/BigCat/blearnword'
import BStrategy from '@/pages/BigCat/bstrategy'
import BStructure from '@/pages/BigCat/bstructure'
import BWordlist from '@/pages/BigCat/bwordlist'
import PAfter from '@/pages/Program/pafter'
import PBefore from '@/pages/Program/pbefore'
import PCard from '@/pages/Program/pcard'
import PExpansion from '@/pages/Program/pexpansion'
import PGame from '@/pages/Program/pgame'
import PLesson from '@/pages/Program/plesson'
import PReview from '@/pages/Program/preview'
import PVideo from '@/pages/Program/pvideo'
import BFVideo from '@/pages/BigCat5/bfvideo'
import PCoreWord from '@/pages/Program/pcoreword'
import PCoreWord1 from '@/pages/Program/pcoreword1'
import PDialogue from '@/pages/Program/pdialogue'
import PBook from '@/pages/Program/pbook'
import PDropQuestion from '@/pages/Program/pdropquestion'
import PChoiceQuestion from '@/pages/Program/pchoicequestion'
import PCourseIntroduce from '@/pages/Program/pcourseintroduce'
import PHeadmaster from '@/pages/Program/pheadmaster'
import PCardGame from '@/pages/Program/pcardgame'
import PParentChildPk from '@/pages/Program/pparentchildpk'
import PPrepareDialogue from '@/pages/Program/ppreparedialogue'
import PAchieve from '@/pages/Program/pachieve'
import PFollow from '@/pages/Program/pfollow'
import pLetterQuestion from '@/pages/Program/pletterquestion'
import PWarmUp from '@/pages/Program/pwarmup'
import PLessonWord from '@/pages/Program/plessonword'
import PGameHome from '@/pages/Program/pgamehome'
import PFamilyTime from '@/pages/Program/pfamilytime'
import PLyric from '@/pages/Program/plyric'
import PShareAward from '@/pages/Program/pshareaward'
import BFChoicequestion from '@/pages/BigCat5/bfchoicequestion'
import BFAfter from '@/pages/BigCat5/bfafter'
import BFCard from '@/pages/BigCat5/bfcard'
import BFFollow from '@/pages/BigCat5/bffollow'
import BFPageWord from '@/pages/BigCat5/bfpageword'
import BFHeadMaster from '@/pages/BigCat5/bfheadmaster'
import BFHighLights from '@/pages/BigCat5/bfhighlights'
import BFCoreWord from '@/pages/BigCat5/bfcoreword'
import BFLesson from '@/pages/BigCat5/bflesson'
import BFExpansion from '@/pages/BigCat5/bfexpansion'
import BFMindMap from '@/pages/BigCat5/bfmindmap'
import BFMindMap2 from '@/pages/BigCat5/bfmindmap2'
import MAfter from '@/pages/MathStart/mafter'
import MCard from '@/pages/MathStart/mcard'
import MCoreWord from '@/pages/MathStart/mcoreword'
import MLessonWord from '@/pages/MathStart/mlessonword'
import MLesson from '@/pages/MathStart/MathLesson/mlesson'
import MExpansion from '@/pages/MathStart/MathExpansion/mexpansion'
import MPractice from '@/pages/MathStart/mpractice'
import MConnectlinequestion from '@/pages/MathStart/mconnectlinequestion'
import WAfter from '@/pages/Worksheet/wafter'

Vue.component('gheader',Gheader)
Vue.use(Router)


const router = new Router({
    mode:'history',
    routes: [
        {
            path: '/pshareaward',
            name: "PShareAward",
            component: PShareAward,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pwarmup',
            name: "PWarmUp",
            component: PWarmUp,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pspeaking',
            name: "PLessonWord",
            component: PLessonWord,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pgamehome',
            name: "PGameHome",
            component: PGameHome,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pfamilytime',
            name: "PFamilyTime",
            component: PFamilyTime,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pconnectlinequestion',
            name: "pConnectLineQuestion",
            component: pConnectLineQuestion,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/',
            name: "Home",
            component: Home,
            props: true,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/before',
            component: Before,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/pletterquestion',
            name: "pLetterQuestion",
            component: pLetterQuestion,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/courseblog',
            name: "CourseBlog",
            component: CourseBlog,
            meta: {
                keepAlive: true,
                requiresAuth: false
            }
        },
        {
            path: '/after',
            name: "After",
            component: After,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/lesson',
            name: 'wordLesson',
            component: Lesson,
            props: true,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/card',
            name: 'wordCard',
            component: Card,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/part',
            name: 'lessonPart',
            component: Part,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/sentence',
            name: 'Sentence',
            component: Sentence,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/quiz',
            name: 'lessonQuiz',
            component: Quiz,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/login',
            name: 'login',
            component: Login,
            meta: {
                notKeepAlive: false
            }
        },
        {
            path: '/selectCode',
            name: 'selectCode',
            component: SelectCode,
            meta: {
                notKeepAlive: false
            }
        },
        {
            path: '/agreement',
            name: 'agreement',
            component: Agreement,
            meta: {
                notKeepAlive: false
            }
        },
        {
            path: '/perfectinfo',
            name: 'perfectinfo',
            component: PerfectInfo,
            meta: {
                notKeepAlive: false
            }
        },
        {
            path: '/pageview',
            name: 'pageView',
            component: PageView,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/excessivebuy',
            name: 'excessivebuy',
            component: ExcessiveBuy,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/sbefore',
            name: "SBefore",
            component: SBefore,
            meta: {
                keepAlive: true,
                requiresAuth: false
            }
        },
        {
            path: '/safter',
            name: "SAfter",
            component: SAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/scard',
            name: "SCard",
            component: SCard,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/slesson',
            name: "SLesson",
            component: SLesson,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/swords',
            name: "SWordList",
            component: SWordList,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/squestion',
            name: "SQuestion",
            component: SQuestion,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/sstrategy',
            name: "SStrategy",
            component: SStrategy,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bafter',
            name: "BAfter",
            component: BAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bbefore',
            name: "BBefore",
            component: BBefore,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/bcard',
            name: "BCard",
            component: BCard,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bfollow',
            name: "BFollow",
            component: BFollow,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/blesson',
            name: "BLesson",
            component: BLesson,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/blearnword',
            name: "BLearnWord",
            component: BLearnWord,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bstrategy',
            name: "BStrategy",
            component: BStrategy,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bstructure',
            name: "BStructure",
            component: BStructure,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bwordlist',
            name: "BWordlist",
            component: BWordlist,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/pafter',
            name: "PAfter",
            component: PAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/pbefore',
            name: "PBefore",
            component: PBefore,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/pcard',
            name: "PCard",
            component: PCard,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/pexpansion',
            name: "PExpansion",
            component: PExpansion,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/pgame',
            name: "PGame",
            component: PGame,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/plesson',
            name: "PLesson",
            component: PLesson,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/preview',
            name: "PReview",
            component: PReview,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pvideo',
            name: "PVideo",
            component: PVideo,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfvideo',
            name: "BFVideo",
            component: BFVideo,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pcoreword',
            name: "PCoreWord",
            component: PCoreWord,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pcoreword1',
            name: "PCoreWord1",
            component: PCoreWord1,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pdialogue',
            name: "PDialogue",
            component: PDialogue,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/ppreparedialogue',
            name: "PPrepareDialogue",
            component: PPrepareDialogue,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pbook',
            name: "PBook",
            component: PBook,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pdropquestion',
            name: "PDropQuestion",
            component: PDropQuestion,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pchoicequestion',
            name: "PChoiceQuestion",
            component: PChoiceQuestion,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pcourseintroduce',
            name: "PCourseIntroduce",
            component: PCourseIntroduce,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pheadmaster',
            name: "PHeadmaster",
            component: PHeadmaster,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pcardgame',
            name: "PCardGame",
            component: PCardGame,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pparentchildpk',
            name: "PParentChildPk",
            component: PParentChildPk,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pachieve',
            name: "PAchieve",
            component: PAchieve,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/pfollow',
            name: "PFollow",
            component: PFollow,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/plyric',
            name: "PLyric",
            component: PLyric,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfchoicequestion',
            name: "BFChoicequestion",
            component: BFChoicequestion,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfafter',
            name: "BFAfter",
            component: BFAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/bfcard',
            name: "BFCard",
            component: BFCard,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bffollow',
            name: "BFFollow",
            component: BFFollow,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfpageword',
            name: "BFPageWord",
            component: BFPageWord,
            meta: {
                keepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfheadmaster',
            name: "BFHeadMaster",
            component: BFHeadMaster,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfhighlights',
            name: "BFHighLights",
            component: BFHighLights,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bfcoreword',
            name: "BFCoreWord",
            component: BFCoreWord,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/bflesson',
            name: "BFLesson",
            component: BFLesson,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/bfexpansion',
            name: "BFExpansion",
            component: BFExpansion,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/bfmindmap',
            name: "BFMindMap",
            component: BFMindMap,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/bfmindmap2',
            name: "BFMindMap2",
            component: BFMindMap2,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/mafter',
            name: "MAfter",
            component: MAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        },
        {
            path: '/mlesson',
            name: "MLesson",
            component: MLesson,
            meta: {
                keepAlive: true,
                requiresAuth: false
            }
        },
        {
            path: '/mlessonword',
            name: "MLessonWord",
            component: MLessonWord,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/mcard',
            name: "MCard",
            component: MCard,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/mcoreword',
            name: "MCoreWord",
            component: MCoreWord,
            meta: {
                notKeepAlive: false,
                requiresAuth: true
            }
        },
        {
            path: '/mexpansion',
            name: "MExpansion",
            component: MExpansion,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/mpractice',
            name: "MPractice",
            component: MPractice,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/mconnectlinequestion',
            name: "MConnectlinequestion",
            component: MConnectlinequestion,
            meta: {
                keepAlive: false,
                requiresAuth: false
            }
        },
        {
            path: '/wafter',
            name: "WAfter",
            component: WAfter,
            meta: {
                keepAlive: true,
                requiresAuth: true
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    // app跳转过来的页面
    if (to.query.token != null && to.query.token.length > 0) {
        // 验证token
        Axios.get("/my/validateKeToken/" + to.query.token).then((response) => {
             let vResult = response.data;

             if (vResult != null) {
                 let vUserId = parseInt(vResult);

                 if (vUserId > 0) {
                     store.dispatch('SetToken', to.query.token);
                     store.dispatch('SetUserId', vUserId.toString());
                     store.dispatch('SetStatusHeight', to.query.statusheight);
                 }
             }

            nextRoute(to, next);
         }).catch(function (error) {
             window.console.log(error)
            nextRoute(to, next);
         });

        return;
    }

    // 网页跳转
    let token = store.state.token;

    if (token != null && token.length > 0) {
        nextRoute(to, next);
    } else {
        Axios.get("/my/checkLogin").then((response) => {
            let vResult = response.data;

            if (vResult != null) {
                let vUserId = parseInt(vResult);

                if (vUserId > 0) {
                    store.dispatch('SetToken', vUserId.toString());
                    store.dispatch('SetUserId', vUserId.toString());
                }
            }

            nextRoute(to, next);
        }).catch(function (error) {
            window.console.log(error)
            nextRoute(to, next);
        });
    }
});

function nextRoute(to, next) {
    let token = store.state.token;

    //判断要去的路由有没有requiresAuth
    if (to.meta.requiresAuth) {
        if (token) {
            next();
        } else {
            next({
                path: '/login',
                // 将刚刚要去的路由path作为参数，方便登录成功后直接跳转到该路由
                query: { redirect: to.fullPath }
            });
        }
    } else {
        next();
    }
}

export default router;
